<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large-plus"
    title="インターネットサイト設定(Type1、イントラネットFW)"
  >
    <template v-slot:body="{ cancel }">
      <cross-validation-observer
        v-slot="{ handleSubmit }"
        :initial-values="{ addressList: addressList, fqdnList: fqdnList }"
        as="div"
      >
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <!-- BODY -->
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-tabs v-model="tabValue" grow hide-slider>
                <v-tab text="アドレス" value="address" />
                <v-tab text="FQDN" value="fqdn" />
              </v-tabs>
              <v-tabs-window v-model="tabValue">
                <v-tabs-window-item value="address">
                  <v-row>
                    <v-col cols="5">
                      <app-badge
                        item="アドレス名"
                        :isRequired="false"
                        :msg="
                          $filter.message('info_max_length', {
                            maxLength: '20',
                          })
                        "
                        placement="end"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-badge
                        item="アドレス"
                        :isRequired="
                          hasInputIpAddressName ||
                          hasCheckZone ||
                          addressList.length !== 1
                        "
                        :msg="
                          $filter.message(
                            'info_cidr_ip_address_of_network_address',
                            {
                              ipaddress1: '61.200.163.0/24',
                              genre: 'アドレス',
                              subnet1: '1',
                              subnet2: '30',
                              ipaddress2: '61.200.163.35/32',
                            }
                          )
                        "
                        placement="end"
                      />
                    </v-col>
                    <v-col>
                      <app-badge
                        item="ゾーン配置"
                        :isRequired="false"
                        :isInfo="false"
                      />
                    </v-col>
                  </v-row>
                  <validation-array
                    name="addressList"
                    v-slot="{ fields, push, remove }"
                  >
                    <template v-for="(item, index) in fields" :key="item.key">
                      <v-row>
                        <v-col cols="5">
                          <validation-provider
                            label="アドレス名"
                            :name="`ipAddressName_${item.key}`"
                            :rules="{ max: { length: 20 } }"
                            v-model="addressList[index].ipAddressName"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-form-input
                              v-bind="componentField"
                              :error-messages="errorMessage"
                              :field-meta="meta"
                            />
                          </validation-provider>
                        </v-col>
                        <v-col cols="4">
                          <validation-provider
                            label="アドレス"
                            :name="`address_${item.key}`"
                            v-model="addressList[index].ipAddress"
                            :rules="{
                              required:
                                !!addressList[index].ipAddressName ||
                                addressList[index].zoneId !== null ||
                                addressList.length !== 1,
                              is_ip_subnet: {
                                min: 1,
                                max: 32,
                                exclude: [31],
                              },
                              is_not_current_ip: true,
                              is_not_loopback_ip: true,
                              is_not_multicast_ip: true,
                              is_not_class_e_ip: true,
                              is_not_broadcast_ip: true,
                              is_network_address: true,
                              duplicate: { list: existsAddress(index) },
                            }"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-form-input
                              v-bind="componentField"
                              :error-messages="errorMessage"
                              :field-meta="meta"
                              :placeholder="
                                $filter.message(
                                  'placeholder_global_ip_address_with_subnet32'
                                )
                              "
                            />
                          </validation-provider>
                        </v-col>
                        <v-col cols="2">
                          <v-checkbox
                            v-model="addressList[index].zoneId"
                            :value="globalZoneId"
                            :false-value="null"
                          />
                        </v-col>
                        <v-col cols="1" v-if="!addressList[index].isDeploy">
                          <v-btn
                            icon="$mdiMinus"
                            size="small"
                            variant="outlined"
                            class="rounded-sm"
                            @click="removeIPAddress(index, remove)"
                          />
                        </v-col>
                      </v-row>
                    </template>
                    <v-row justify="end">
                      <v-col cols="1">
                        <v-btn
                          icon="$mdiPlus"
                          size="small"
                          variant="outlined"
                          class="rounded-sm"
                          @click="addIPAddress(push)"
                        />
                      </v-col>
                    </v-row>
                  </validation-array>
                </v-tabs-window-item>
                <v-tabs-window-item value="fqdn">
                  <v-row>
                    <v-col cols="5">
                      <app-badge
                        item="FQDN名"
                        :isRequired="false"
                        :msg="
                          $filter.message('info_max_length', {
                            maxLength: '20',
                          })
                        "
                        placement="end"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-badge
                        item="FQDN"
                        :isRequired="
                          hasInputFqdnName ||
                          hasCheckFqdnZone ||
                          fqdnList.length !== 1
                        "
                        :msg="$filter.message('info_fqdn')"
                        placement="end"
                      />
                    </v-col>
                    <v-col>
                      <app-badge
                        item="ゾーン配置"
                        :isRequired="false"
                        :isInfo="false"
                      />
                    </v-col>
                  </v-row>
                  <validation-array
                    name="fqdnList"
                    v-slot="{ fields, push, remove }"
                  >
                    <template v-for="(item, index) in fields" :key="item.key">
                      <v-row>
                        <v-col cols="5">
                          <validation-provider
                            label="FQDN名"
                            :name="`fqdnName_${item.key}`"
                            :rules="{ max: { length: 20 } }"
                            v-model="fqdnList[index].fqdnName"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-form-input
                              v-bind="componentField"
                              :error-messages="errorMessage"
                              :field-meta="meta"
                            />
                          </validation-provider>
                        </v-col>
                        <v-col cols="4">
                          <validation-provider
                            label="FQDN"
                            :name="`fqdn_${item.key}`"
                            v-model="fqdnList[index].fqdn"
                            :rules="{
                              required:
                                !!fqdnList[index].fqdnName ||
                                fqdnList[index].zoneId !== null ||
                                fqdnList.length !== 1,
                              is_fqdn: true,
                              is_not_both: { notBoth: ['-', '.'] },
                              min: { length: 3 },
                              max: { length: 255 },
                              duplicate: { list: existsFqdn(index) },
                            }"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-form-input
                              v-bind="componentField"
                              :error-messages="errorMessage"
                              :field-meta="meta"
                            />
                          </validation-provider>
                        </v-col>
                        <v-col cols="2">
                          <v-checkbox
                            v-model="fqdnList[index].zoneId"
                            :value="globalZoneId"
                            :false-value="null"
                          />
                        </v-col>
                        <v-col cols="1" v-if="!fqdnList[index].isDeploy">
                          <v-btn
                            icon="$mdiMinus"
                            size="small"
                            variant="outlined"
                            class="rounded-sm"
                            @click="removeFqdn(index, remove)"
                          />
                        </v-col>
                      </v-row>
                    </template>
                    <v-row justify="end">
                      <v-col cols="1">
                        <v-btn
                          icon="$mdiPlus"
                          size="small"
                          variant="outlined"
                          class="rounded-sm"
                          @click="addFqdn(push)"
                        />
                      </v-col>
                    </v-row>
                  </validation-array>
                </v-tabs-window-item>
              </v-tabs-window>
            </div>
            <!--  関連項目チェック：ゾーン配置をチェックする場合ゾーンが存在すること -->
            <cross-validation-provider
              :passed="noGlobalZone"
              vid="noGlobalZone"
              class="my-4"
            >
              グローバルゾーンが存在しません。設定してから配置してください。
            </cross-validation-provider>
          </v-card-text>

          <v-divider></v-divider>
          <!-- FOOTER -->
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" variant="flat" color="primary"
                  >変更
                </v-btn>
                <v-btn variant="outlined" color="primary" @click="cancel"
                  >キャンセル
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </cross-validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type {
  PostType1InternetSite,
  PutType1InternetAddress,
  PutType1InternetFQDN,
  Type1InternetInfo,
} from "@/apis/Type1SiteApi";
import { VueFinalModal } from "vue-final-modal";

export default defineComponent({
  name: "InternetSiteModify",
  props: {
    internetSiteZone: {
      type: Object as PropType<Type1InternetInfo>,
      required: true,
    },
  },
  data() {
    return {
      tabValue: "address",
      globalZoneId: this.internetSiteZone.zone?.zoneId || "none",
      addressList:
        this.internetSiteZone.addressList.length === 0
          ? [
              {
                ipAddressId: null,
                ipAddressName: "",
                ipAddress: "",
                zoneId: null,
                isDeploy: false,
              },
            ]
          : (this.internetSiteZone.addressList.map((e) => ({
              ...e,
              isDeploy: !!e.zoneId,
            })) as PutType1InternetAddress[]),
      fqdnList:
        this.internetSiteZone.fqdnList.length === 0
          ? [
              {
                fqdnId: null,
                fqdnName: "",
                fqdn: "",
                zoneId: null,
                isDeploy: false,
              },
            ]
          : (this.internetSiteZone.fqdnList.map((e) => ({
              ...e,
              isDeploy: !!e.zoneId,
            })) as PutType1InternetFQDN[]),
    };
  },
  computed: {
    /** 既存のIPアドレス */
    existsAddress() {
      // 既存のアドレスリストに同じIPアドレスが存在した場合はエラーとする
      return (index: number) => {
        return this.addressList
          .filter((_, num) => num !== index)
          .map((v) => v.ipAddress);
      };
    },
    /** 既存のFQDN */
    existsFqdn() {
      // 既存のFQDNリストに同じFQDNが存在した場合はエラーとする
      return (index: number) => {
        return this.fqdnList
          .filter((_, num) => num !== index)
          .map((v) => v.fqdn);
      };
    },
    /** 関連項目チェック:zoneがnull場合ゾーン配置をチェック */
    noGlobalZone(): boolean {
      return !(
        this.addressList.some((item) => item.zoneId === "none") ||
        this.fqdnList.some((item) => item.zoneId === "none")
      );
    },
    /** アドレス名入力済みの場合は,true */
    hasInputIpAddressName(): boolean {
      return this.addressList.some((v) => v.ipAddressName);
    },
    /** ゾーン配置チェック済みの場合は,true */
    hasCheckZone(): boolean {
      return this.addressList.some((v) => v.zoneId);
    },
    /** FQDN名入力済みの場合は,true */
    hasInputFqdnName(): boolean {
      return this.fqdnList.some((v) => v.fqdnName);
    },
    /** FQDNゾーン配置チェック済みの場合は,true */
    hasCheckFqdnZone(): boolean {
      return this.fqdnList.some((v) => v.zoneId);
    },
  },

  methods: {
    /** 変更機能 */
    async submit() {
      await this.$confirm(
        "インターネットサイト設定を変更します。よろしいですか？"
      );

      // 変更データの設定
      const reqData: PostType1InternetSite = {
        addressList:
          this.addressList.length === 1 && !this.addressList[0].ipAddress
            ? []
            : this.addressList.map((e) => ({
                ipAddressId: e.ipAddressId,
                ipAddressName: e.ipAddressName || null,
                ipAddress: e.ipAddress,
                zoneId: e.zoneId,
              })),
        fqdnList:
          this.fqdnList.length === 1 && !this.fqdnList[0].fqdn
            ? []
            : this.fqdnList.map((e) => ({
                fqdnId: e.fqdnId,
                fqdnName: e.fqdnName || null,
                fqdn: e.fqdn,
                zoneId: e.zoneId,
              })),
        type1SiteZoneKeyId: this.internetSiteZone.type1SiteZoneKeyId,
      };
      await this.$api.type1SiteZone.postType1InternetSite(reqData);
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /**
     * IPAddress追加機能
     * 押下時一行追加
     */
    addIPAddress(push: (item: any) => void) {
      const addItem = {
        ipAddressId: null,
        ipAddressName: "",
        ipAddress: "",
        zoneId: null,
        isDeploy: false,
      };
      this.addressList.push(addItem);
      push(addItem);
    },
    /**
     * fqdn追加機能
     * 押下時一行追加
     */
    addFqdn(push: (item: any) => void) {
      const addItem = {
        fqdnId: null,
        fqdnName: "",
        fqdn: "",
        zoneId: null,
        isDeploy: false,
      };
      this.fqdnList.push(addItem);
      push(addItem);
    },
    /**
     * IPAddress削除機能
     * 押下時その行削除
     * 一行しかない場合その行クリア
     */
    removeIPAddress(index: number, remove: (idx: number) => void) {
      if (this.addressList.length > 1) {
        this.addressList.splice(index, 1);
        remove(index);
      } else {
        this.addressList = [
          {
            ipAddressId: null,
            ipAddressName: "",
            ipAddress: "",
            zoneId: null,
            isDeploy: false,
          },
        ];
      }
    },
    /**
     * fqdn削除機能
     * 押下時その行削除
     * 一行しかない場合その行クリア
     */
    removeFqdn(index: number, remove: (idx: number) => void) {
      if (this.fqdnList.length > 1) {
        this.fqdnList.splice(index, 1);
        remove(index);
      } else {
        this.fqdnList = [
          {
            fqdnId: null,
            fqdnName: "",
            fqdn: "",
            zoneId: null,
            isDeploy: false,
          },
        ];
      }
    },
  },
});
</script>

<style lang="scss" scoped>
:deep(.v-input--density-default) {
  --v-input-control-height: 40px;
}
.modal-body {
  min-height: 55vh;
}
</style>
